<template>
    <div class="publish hvh-flex align-center font-sm no-line-height" v-if="publishedClients.length">
      <v-icon class="ml-1" color="white" small>mdi-checkbox-marked-circle</v-icon>
      <span class="ml-1">Published to: {{publishedClients}}</span>
    </div>
</template>

<script>
export default {
  props: ['value'],
  computed: {
    publishedClients(){
       return this.value.map(f=>f.clientName).join(', ');
    }
  }
}
</script>

<style lang="scss" scoped>
.publish{
  background: linear-gradient(90deg, #23B4B0 0%, #23B4B0 100%);
  color: #ffffff;
  font-weight: 600;
  letter-spacing: 0.2px;
  padding: 1px 1px 0 1px;
}
</style>